'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.accessReview', [])

.factory('accessReviewService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/AccessReview/API';

    service.getCurrentAccessReview = function () {
        return $http.get(baseUrl + '/GetCurrentAccessReview', { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.needAccessReview = function (authLogin) {
        return $http.get(baseUrl + '/NeedAccessReview/' + authLogin, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
